module.exports = __webpack_public_path__ + "static/profile-23333b9481dd5068383f6876dab35fb9.png";